import React, { useMemo, useState } from "react";
import AvatarName from "./AvatarName";
import { ReactComponent as Calender } from "../../assets/images/icons/NewCalenderIcon.svg";
import { ReactComponent as Recursion } from "../../assets/images/icons/NewRecurenceIcon.svg";
import { ReactComponent as Activity } from "../../assets/images/icons/menu.svg";
import { ReactComponent as Link } from "../../assets/images/icons/Link.svg";
import { ReactComponent as Share } from "../../assets/images/icons/Share.svg";
import { ReactComponent as CardLink } from "../../assets/images/icons/CardLink.svg";
import ToolTipComponent from "./ToolTipComponent";
import { getDDMonthYYYY } from "../../utils/utilityFunctions/dateConvert";
import { ReactComponent as NewLeadIcon } from "../../assets/images/icons/NewLeadIcon.svg";
import { ReactComponent as NewTaskIcon } from "../../assets/images/icons/NewTaskIcon.svg";
import { ReactComponent as NewOtherIcon } from "../../assets/images/icons/NewOtherIcon.svg";
import { ReactComponent as NewDealIcon } from "../../assets/images/icons/NewDealIcon.svg";
import { ReactComponent as SquareBoxHalf } from "../../assets/images/icons/SquareBoxHalf.svg";
import { ReactComponent as CardActivity } from "../../assets/images/icons/CardAttachment.svg";
import { ReactComponent as CardAttach } from "../../assets/images/icons/Attachment.svg";
import { ReactComponent as CardSubTask } from "../../assets/images/icons/CardSubTask.svg";
import {
  getHexWithOpacity,
  getSentenceCase,
  getTitleCase,
  safeJsonParse,
} from "../../utils/utilityFunctions/stringUtility";
import { hexToRgba } from "../../utils/utilityFunctions/color";
import { getUserDateTime } from "../../utils/utilityFunctions/UTCFormat";

const escapeRegExp = (string) => string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
const highlightText = (text, query) => {
  if (!query || typeof text !== "string") return text;
  const words = query.trim().toLowerCase().split(/\s+/).filter(Boolean);
  if (!words.length) return text;
  const regex = new RegExp(`(${words.map(escapeRegExp).join("|")})`, "gi");

  return text.split(regex).map((part, i) =>
    words.includes(part.toLowerCase()) ? (
      <span key={i} className="bg-yellow-200">
        {part}
      </span>
    ) : (
      part
    )
  );
};

const toPascalCase = (str) =>
  str
    ?.toLowerCase()
    ?.split(" ")
    ?.map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(" ");

const UniversalCardComponent = ({
  item,
  nameArr,
  onClick,
  isTaskCompleted,
  TaskCompletionCheckbox,
  searchValue,
  recentlyDroppedItemId,
  setSeriesRecurModel,
  isAddButtonActive,
  handleUnlink,
  handleLink,
  isSecondStyle = false,
  statusColorCustomer,
  linkedTask = false,
  isSubTask = false,
  isCheckBoxShow = false,
  isStatusShow = false,
  isActionsShow = false,
  isReccurenceShow = false,
  isTagsShow = false,
  isSquareBox = false,
}) => {
  // const imageICons = {
  //   task: <NewTaskIcon />,
  //   lead: <NewLeadIcon />,
  //   deal: <NewDealIcon />,
  //   Other: <NewOtherIcon />,
  // };

  const ColorMap = {
    task: "#3B82F6",
    lead: "#A78BFA",
    deal: "#10B981",
  };

  const [isLoading, setIsLoading] = useState(false);
  const handleLinkUnlinked = async () => {
    try {
      setIsLoading(() => true);
      if (isAddButtonActive) {
        await handleLink(item?.id);
      } else {
        await handleUnlink(item?.id);
      }
    } catch (error) {
      console.log(error?.message);
    } finally {
      setIsLoading(() => false);
    }
  };

  return (
    <div
      className={`w-full h-full cursor-pointer shadow hover:shadow-card hover:bg-primary-hover rounded-lg  ${!isSecondStyle ? "border border-[#D2DAE1] p-1" : `p-2`} ${isTaskCompleted ? "opacity-60" : "bg-white"} relative`}
      {...(!isSquareBox && {
        onMouseEnter: (e) =>
          (e.currentTarget.style.backgroundColor = isTaskCompleted
            ? "#f9f9f9"
            : hexToRgba(item?.status_colour_code || statusColorCustomer, 0.07)),
        onMouseLeave: (e) => (e.currentTarget.style.backgroundColor = isTaskCompleted ? "#f9f9f9" : "white"),
      })}
    >
      {isSquareBox && (
        <span className={`absolute`}>
          <SquareBoxHalf
            fill={item.status_colour_code ? item?.status_colour_code : ColorMap[item.category_id.toLowerCase()]}
          />
        </span>
      )}

      <div
        className={`w-full flex flex-col justify-star gap-y-2t ${!isSecondStyle ? "px-3 py-3" : ""} rounded-lg relative`}
      >
        {/* Header */}
        <div className="flex gap-2 h-full">
          {/* <div className="flex items-center gap-x-1 text-[#868686]">
              {imageICons[item?.category_id]}
              <span className="text-xs px-1 z-10 font-poppins">
                {highlightText(toPascalCase(item?.category_id), searchValue)}
              </span>
            </div> */}

          {/* priority */}
          {/* {item?.priority && (
              <span
                className="rounded-full py-1 px-2 text-xs"
                style={{
                  color: item?.priority_colour_code,
                  backgroundColor: `${item?.priority_colour_code}20`,
                }}
              >
                {highlightText(item?.priority, searchValue)}
              </span>
            )} */}
        </div>

        {/* Subject */}
        <div
          className={`flex items-start w-full truncate gap-x-2 justify-between mb-2 ${isSecondStyle ? ` px-2  py-1   ${statusColorCustomer ? "rounded-none" : "rounded-md"}` : ""}`}
          // style={{
          //   backgroundColor: isSecondStyle
          //     ? hexToRgba(item?.status_colour_code || statusColorCustomer, 0.1)
          //     : "transparent",
          // }}
        >
          <div className="flex items-center justify-start gap-x-1 w-full">
            {isCheckBoxShow && (
              <span className="inline-block scale-90">
                <TaskCompletionCheckbox
                  id={item?.id}
                  task_status_id={item?.task_status_id}
                  taskData={item}
                  isChecked={isTaskCompleted}
                />
              </span>
            )}

            <span
              className={`truncate max-w-[25ch] text-[#131313CC] text-[13px] font-medium }`}
              style={isSecondStyle ? { color: item?.status_colour_code || statusColorCustomer } : {}}
            >
              {highlightText(getTitleCase(item?.subject), searchValue)}
            </span>
          </div>

          {/* status */}

          {isStatusShow && (
            <span
              className="flex items-center px-2 text-xs rounded-md py-1"
              style={{
                color: item?.status_colour_code || statusColorCustomer,
                border: `1px solid ${item?.status_colour_code || statusColorCustomer}`,
              }}
            >
              {highlightText(getTitleCase(item?.status), searchValue)}
            </span>
          )}
        </div>

        {/* Tags */}
        {isTagsShow && item?.tag?.length > 0 && (
          <div className={`flex flex-wrap gap-2 pl-0.5 ${item?.tag?.length > 0 ? "pb-2.5 pt-1" : ""}`}>
            {item?.tag?.map((tag, i) => (
              <span
                key={i}
                className="rounded-md py-[3px] px-3 text-[11px]"
                // style={{
                //   backgroundColor: tag.bg_color_code || "#ccc",
                //   color: tag.colour_code,
                // }}
                style={{
                  backgroundColor: getHexWithOpacity(tag.bg_color_code, 10) || "#ccc",
                  color: tag.bg_color_code,
                  border: `1px solid ${getHexWithOpacity(tag.bg_color_code, 20)}`,
                }}
              >
                {highlightText(tag?.tag_name, searchValue)}
              </span>
            ))}
          </div>
        )}

        {/* Dates */}
        <div className={`flex justify-between items-center ${isSecondStyle ? "px-2" : ""}`}>
          <div
            className={`flex   text-[#868686]  gap-x-2.5 ml-0.5  ${isSecondStyle ? "text-[11px] font-medium" : "text-sm font-medium"}`}
          >
            <Calender className={`${isSecondStyle ? "h-4 w-4" : ""}`} />
            <span>
              {highlightText(getUserDateTime(item?.start_date, "toLocal", "dateOnly"), searchValue)}
              {item?.start_date !== item?.end_date && (
                <> - {highlightText(getUserDateTime(item?.end_date, "toLocal", "dateOnly"), searchValue)}</>
              )}
            </span>
          </div>

          {Boolean(item?.is_recurrence) && (
            <div>
              <ToolTipComponent text={"Recurrence"} darkMode>
                <Recursion
                  className={`${"fill-primary"} cursor-pointer hover:fill-blue-bg-gray-200`}
                  // className={`cursor-pointer h-7 w-7`}
                  onClick={(e) => {
                    e.stopPropagation();
                    if (isTaskCompleted) {
                      return;
                    } else {
                      onClick?.({ ...item, recurModal: true });
                      // setSeriesRecurModel(true);
                      setSeriesRecurModel?.(true);
                    }
                  }}
                />
              </ToolTipComponent>
            </div>
          )}
        </div>
      </div>

      {/* Footer */}
      <div
        className={`flex justify-between items-center text-sm ${isSecondStyle ? "py-2.5 px-1.5" : "px-3 pb-3"} relative `}
      >
        <div className="flex items-center ml-1 ">
          {item?.assigned_to?.length > 1 ? (
            <div className="flex">
              {safeJsonParse(item.assigned_to)
                .slice(0, 3)
                .map((user, i) => {
                  const initials = user.name
                    .split(" ")
                    .map((w) => w[0])
                    .join("")
                    .slice(0, 2)
                    .toUpperCase();
                  return (
                    <div key={i} className="relative ml-[-5px] border rounded-full border-white">
                      <AvatarName
                        name={highlightText(initials, searchValue)}
                        size="small"
                        bgColor={user.c_key}
                        textColor="ffffff"
                      />
                    </div>
                  );
                })}
              <div className="ml-[-5px] ">
                <AvatarName
                  name={`+${item.assigned_to.length}`}
                  size="small"
                  bgColor="#D8EEF7"
                  textColor="#000000"
                  borderColor="white"
                />
              </div>
            </div>
          ) : (
            item?.assigned_to.map((user, i) => {
              const initials = user.name
                .split(" ")
                .map((w) => w[0])
                .join("")
                .slice(0, 2)
                .toUpperCase();
              return (
                <div key={i} className="flex items-center ml-[-5px] gap-x-2">
                  <AvatarName
                    name={highlightText(initials, searchValue)}
                    size="medium"
                    bgColor={user.c_key}
                    textColor="ffffff"
                  />
                  <div className="text-[#383838] font-poppins text-[11px] font-normal capitalize">
                    {highlightText(user.name, searchValue)}
                  </div>
                </div>
              );
            })
          )}
        </div>

        <div className="flex gap-1  items-center">
          {item?.is_activity && (
            <div className="flex group items-center justify-center h-6 w-6 rounded-md border border-[#868686] bg-gray-100  hover:bg-primary-active">
              <ToolTipComponent text={"Activity"} darkMode>
                <CardActivity
                  onClick={(e) => {
                    e.stopPropagation();
                    onClick?.({ ...item, activeModal: true });
                  }}
                />
              </ToolTipComponent>
            </div>
          )}

          {item?.is_linked && (
            <ToolTipComponent text={isAddButtonActive ? "Link" : "Unlink"} darkMode>
              <div className="flex group items-center justify-center h-6 w-6 rounded-md border border-[#868686] bg-gray-100   hover:bg-primary-active">
                <CardLink
                  onClick={(e) => {
                    e.stopPropagation();
                    handleLinkUnlinked();
                  }}
                />
              </div>
            </ToolTipComponent>
          )}

          {item?.sub_tasks?.length > 0 && (
            <ToolTipComponent text={isAddButtonActive ? "Link" : "Unlink"} darkMode>
              <div className="flex group items-center justify-center h-6 w-6 rounded-md border border-[#868686] bg-gray-100   hover:bg-primary-active">
                <CardSubTask
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                />
              </div>
            </ToolTipComponent>
          )}

          {item?.attachments?.length > 0 && (
            <ToolTipComponent text={"Attachment"} darkMode>
              <div className="flex group items-center justify-center h-6 w-6 rounded-md border border-[#868686]  bg-gray-100 hover:bg-primary-active">
                <CardAttach onClick={(e) => e.stopPropagation()} />
              </div>
            </ToolTipComponent>
          )}
        </div>
      </div>
    </div>
  );
};

export default UniversalCardComponent;
